export default __webpack_public_path__ + "static/media/Malgun-Gothic-Regular.a41f507b.ttf";